import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=02e0cb12&scoped=true&lang=pug"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"
import style0 from "./MessageForm.vue?vue&type=style&index=0&id=02e0cb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e0cb12",
  null
  
)

export default component.exports